export enum ConfirmationModalType {
  DEFAULT = 'DEFAULT',
  DESTRUCTIVE = 'DESTRUCTIVE'
}
